import script from "./mobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./mobile.vue?vue&type=script&lang=ts&setup=true"

import "./mobile.vue?vue&type=style&index=0&id=9c52ed02&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c52ed02"]])

export default __exports__